import { isDefined } from "@clipboard-health/util-ts";

import { PreShiftOrientationCard } from "../../../Shift/PreShiftOrientation/OrientationCard";
import { useBookedShiftOrientation } from "../../../Shift/PreShiftOrientation/useBookedShiftOrientation";

interface BookedShiftOrientationCardProps {
  shiftId: string;
  shiftStart: string;
  workplaceTimezone?: string;
}

export function BookedShiftOrientationCard(props: BookedShiftOrientationCardProps) {
  const { shiftId, shiftStart, workplaceTimezone } = props;
  const { hasPreShiftOrientation, adjustedStart, orientationLengthInMinutes } =
    useBookedShiftOrientation({
      id: shiftId,
      start: shiftStart,
    });

  if (
    !hasPreShiftOrientation ||
    !isDefined(adjustedStart) ||
    !isDefined(orientationLengthInMinutes)
  ) {
    return null;
  }

  return (
    <PreShiftOrientationCard
      adjustedStart={adjustedStart}
      orientationLengthInMinutes={orientationLengthInMinutes}
      timeZone={workplaceTimezone}
    />
  );
}
